import { pageHelp } from "@/lib/help-texts";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PageHelp({ page }) {
	const [open, setOpen] = useState(false);
	const help = pageHelp[page];
	if (!help) return null;
	return _jsxs("div", {
		className: "mb-4 rounded-lg border border-blue-100 bg-blue-50/50",
		children: [
			_jsxs("button", {
				type: "button",
				onClick: () => setOpen(!open),
				className: "flex w-full items-center justify-between px-4 py-2.5 text-left text-sm",
				children: [
					_jsxs("span", {
						className: "flex items-center gap-2 font-medium text-blue-700",
						children: [
							_jsx("svg", {
								className: "h-4 w-4",
								fill: "none",
								stroke: "currentColor",
								viewBox: "0 0 24 24",
								children: _jsx("path", {
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 2,
									d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
								}),
							}),
							help.description,
						],
					}),
					_jsx("svg", {
						className: `h-4 w-4 shrink-0 text-blue-400 transition-transform ${open ? "rotate-180" : ""}`,
						fill: "none",
						stroke: "currentColor",
						viewBox: "0 0 24 24",
						children: _jsx("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "M19 9l-7 7-7-7",
						}),
					}),
				],
			}),
			open &&
				help.tips &&
				_jsx("ul", {
					className: "border-t border-blue-100 px-4 py-2.5 text-xs text-blue-600",
					children: help.tips.map((tip) =>
						_jsxs(
							"li",
							{
								className: "flex items-start gap-1.5 py-0.5",
								children: [
									_jsx("span", { className: "mt-0.5 text-blue-400", children: "\u2023" }),
									tip,
								],
							},
							tip,
						),
					),
				}),
		],
	});
}
//# sourceMappingURL=PageHelp.js.map
